import type { NotificationOptimisticReadList } from "./notification-optimistic-read.type";
import type { NotificationDatabaseEntity } from "@/entities/notification-database";

import { atom } from "jotai";

export const notificationOptimisticReadListAtom =
  atom<NotificationOptimisticReadList>([]);

export const addToOptimisticListAtom = atom(
  null,
  (get, set, notifId: NotificationDatabaseEntity["id"]) => {
    const currentList = get(notificationOptimisticReadListAtom);
    set(notificationOptimisticReadListAtom, [...currentList, notifId]);
  }
);

export const removeFromOptimisticListAtom = atom(
  null,
  (get, set, notifId: NotificationDatabaseEntity["id"]) => {
    const currentList = get(notificationOptimisticReadListAtom);
    const newList = currentList.filter((id) => id !== notifId);
    set(notificationOptimisticReadListAtom, newList);
  }
);
